// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"68c42930","126":"216a2067","323":"bf408f50","739":"6beadf80","789":"04ae71f7"}[chunkId] + ".chunk.css";
};